// DWM logo: red Monitor mark + product name. Five taps within 2 s open the demo menu (mobile has no ⌘.).
import { useRef } from 'react';
import { DwmLogo } from '../icons';
import { openDemoMenu } from './demoBus';
import s from './Shell.module.css';

export function Logo({ large }: { large?: boolean }) {
  const taps = useRef<number[]>([]);
  const onTap = () => {
    const now = Date.now();
    taps.current = [...taps.current.filter((t) => now - t < 2000), now];
    if (taps.current.length >= 5) { taps.current = []; openDemoMenu(); }
  };
  return (
    <button type="button" className={`${s.logo} ${large ? s.logoLarge : ''}`} onClick={onTap} data-testid="logo" aria-label="Nord Monitor">
      <DwmLogo size={large ? 28 : 24} />
      <span className={s.logoText}>Nord Monitor</span>
    </button>
  );
}
